// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rm-0";